import React from 'react'
import { ITabsContextProp, withTabsContext } from '../common/Tabs'
import PeopleTab, { IPeopleTabProps } from './PeopleTab'

type PublicPeopleTabProps = Omit<IPeopleTabProps, 'classes'>

type Props = PublicPeopleTabProps & ITabsContextProp

// wrapper for PeopleTab that includes a next button for navigating the group tabs
const PeopleTabWithNext: React.FC<Props> = ({
  tabs,
  hasTabs = false, // only when checklist.useTabs is true
  ...peopleProps
}) => {
  const nextTabHandler = hasTabs && tabs ? tabs.nextTab : undefined

  return (
    <PeopleTab
      {...(peopleProps as IPeopleTabProps)}
      hasTabs={hasTabs}
      nextTab={nextTabHandler}
    />
  )
}

export default withTabsContext(PeopleTabWithNext)
